/* eslint-disable react/prop-types */
import React from 'react';
import { useTranslation } from 'react-i18next';
// mui
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

const LanguagesInfo = ({ cvDetails }) => {
  const { t } = useTranslation('global');

  const { languages = [] } = cvDetails;

  return (
    <div className='languagesSection'>
      <h4>
        {t('cvDescription.additionalLanguages')}
      </h4>
      <div className='languagesBox'>
        {
          languages?.map(i => (
            <p key={i.id}>
              <FiberManualRecordIcon sx={{ mr: '8px', width: '10px', height: '10px', color: '#294A9C' }} />
              {i.lng}
              {' - '}
              <span>
                {i.lng_skill}
              </span>
            </p>
          ))
        }
      </div>
    </div>
  );
};

export default LanguagesInfo;
